/* eslint-disable no-console */
import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import { getClientes } from "../../../utils";

/**
 * Hook que gestiona la carga de clientes con filtro por rol/ejecutivo.
 */
export function useClientesData({ pais, rol, userId }) {
  const [clientes, setClientes] = useState([]);
  const [clientesLoading, setClientesLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setClientesLoading(true);
      try {
        const [clientesData] = await Promise.all([getClientes({ pais })]);
        let filteredClientes = clientesData;
        if (pais !== "Perú") {
          if (rol === "comercial") {
            filteredClientes = clientesData.filter((cliente) => {
              const esPrincipal = String(cliente.ejecutivo) === String(userId);
              const asignados = cliente.ejecutivos_asignados || [];
              const estaEnAsignados = asignados.map(String).includes(String(userId));
              return esPrincipal || estaEnAsignados;
            });
          } else if (rol === "gerencia" || rol === "superadmin") {
            filteredClientes = clientesData;
          }
        }
        setClientes(filteredClientes);
      } catch (error) {
        if (process.env.NODE_ENV !== "production") {
          console.error("Error al obtener datos:", error);
        }
        toast.error("No se pudieron cargar los datos.");
      } finally {
        setClientesLoading(false);
      }
    };
    fetchData();
  }, [pais, rol, userId]);

  const renderClientesOptions = () => {
    const clientesOrdenados = [...new Set(clientes.map((cliente) => cliente.nombre))].sort();
    return clientesOrdenados.map((cliente, index) => (
      <option key={index} value={cliente}>
        {cliente}
      </option>
    ));
  };

  return {
    clientes,
    clientesLoading,
    renderClientesOptions,
  };
}
